












































































import { Component, Vue } from 'vue-property-decorator';
import MenuItem from '@/components/Global/Menu/Item.vue';
import Dropdown from '@/components/Global/Menu/Dropdown.vue';
import Auth from '@/services/Auth';
import { Getter } from 'vuex-class';
import { getSettings } from '@/services/Settings';

@Component({
	name: 'RiskResources',
	components: {
		MenuItem,
		Dropdown,
	},
})
export default class RiskResources extends Vue {
	private Auth: typeof Auth = Auth;
	@Getter('riskResourcesRequested', { namespace: 'Registration' })
	private riskResourcesRequested: boolean;
	private environment = process.env.VUE_APP_ENV_TYPE;

	private agentResourcesStatus: boolean = false;

	private async created() {
		try {
			const getLiveChatStatus = await getSettings(['agentResourcesStatus']);
			this.agentResourcesStatus = getLiveChatStatus.data.find(
				s => s.setting_key === 'agentResourcesStatus',
			).active;
		} catch (e) {
			console.log(e);
		}
	}

	get isRiskResourcesSelected() {
		if (this.riskResourcesRequested) {
			return true;
		}
		return false;
	}
}
